import type { CoverSheetConfigCard } from '../../types';

export const importantDatesCard = {
  id: 'propertyInfo.importantDates',
  innerTitle: 'Important Dates',
  legend: '',
  layout: [
    [
      {
        name: 'contractDate',
        size: 33,
      },
      {
        name: 'listingStartDate',
        size: 33,
      },
      {
        name: 'listingEndDate',
        size: 33,
      },
    ],
    [
      {
        name: 'onMarketDate',
        size: 33,
      },
      {
        name: 'closingDate',
        size: 33,
      },
      {
        name: '_',
        size: 33,
      },
    ],
  ],
  fields: {
    contractDate: {
      name: 'contractDate',
      entity: 'interaction',
      type: 'date',
      label: 'Contract Date',
      placeholderText: '',
    },
    listingStartDate: {
      name: 'listingStartDate',
      entity: 'interaction',
      type: 'date',
      label: 'Listing Start Date',
      placeholderText: '',
    },
    listingEndDate: {
      name: 'listingEndDate',
      entity: 'interaction',
      type: 'date',
      label: 'Listing End Date',
      placeholderText: '',
    },
    onMarketDate: {
      name: 'onMarketDate',
      entity: 'interaction',
      type: 'date',
      label: 'On Market Date',
      placeholderText: '',
    },
    closingDate: {
      name: 'closingDate',
      entity: 'interaction',
      type: 'closingDate',
      label: 'Closing Date',
      placeholderText: '',
    },
  },
} satisfies CoverSheetConfigCard;
